export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAxNiAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjUgMjQuNjg5NkwyLjgyOTQxIDE0LjIxN0MyLjM4NjU4IDEzLjgxOTYgMi4zODY1OCAxMy4xMjU4IDIuODI5NDEgMTIuNzI4NUwxNC41IDIuMjU1ODYiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow-next.svg
// module id = 276
// module chunks = 0 5 6 14